// EUR money formatter — European-style "€1.234,56"
export function formatEur(amount, locale = "hr") {
  const n = Number(amount || 0);
  try {
    return new Intl.NumberFormat(locale === "hr" ? "hr-HR" : locale, {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    return `€${n.toFixed(2)}`;
  }
}

export function formatEurPlain(amount) {
  const n = Number(amount || 0);
  return `€${n.toLocaleString("hr-HR", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}
